import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { User } from 'src/app/models/user';
import { TravelService } from 'src/app/modules/travel/services/travel/travel.service';
import { AddressService } from 'src/app/modules/shared/services/address/address.service';
import { UserIdleService } from 'angular-user-idle';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  
  password =  true;
  isCheck = false;

  loading:boolean = false;
  remmember:boolean =  false;

  usernameError = '';
  passwordError = '';
  
  loginForm: FormGroup;
  _login = new User('');

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private travelService: TravelService,
    public addressService: AddressService,
    private _router: Router,
    private userIdle: UserIdleService
  ) {}

  ngOnInit() {
    this.userIdle.stopWatching();
    this.clearStorage();
    this.loginForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]]
    });
    this.getRememberDetail();
  }

  login(event) {
    this.loading = true;
    let data = this.loginForm.value;

    if (this.remmember) {
      localStorage.setItem('Remember', 'true');
      localStorage.setItem('Password',this.loginForm.controls['password'].value);
      localStorage.setItem('Email',this.loginForm.controls['email'].value);
    }

    this.auth.login(data).subscribe(response => {
      this.auth.setAuthUser(response);
      this.auth.setAuthToken(response.token);

  
      if (this.auth.url) {
        this._router.navigateByUrl(this.auth.url);
        this.auth.url = null;
      } else {
        this._router.navigate(["/dashboard"]);
      }
      
      this.travelService.getDepartment().subscribe(res=>{
        localStorage.setItem('department', JSON.stringify(res));
      });

      this.travelService.getPosition().subscribe(res=>{
        localStorage.setItem('position', JSON.stringify(res));
      });

      this.addressService.getProvince().subscribe(res=>{
        localStorage.setItem('province', JSON.stringify(res));
      });
      this.addressService.getCountry().subscribe(res=>{
        localStorage.setItem('country', JSON.stringify(res));
      });

      this.addressService.getCityList().subscribe(res=>{
        localStorage.setItem('citylist', JSON.stringify(res));
      });

      this.auth.getEmployee().subscribe(res => {
        localStorage.setItem('employeelist', JSON.stringify(res));
      });

      this.loading = false;
    },(err => {
      this.loading = false;
      this._login = new User('');
      this._login.setErrors(err.error);
      this.triggerErrors(err.error.errors);
    }));
  }

  toggle(e) {
    if (e.checked) {
        this.remmember = true;
        localStorage.setItem('Remember', e.checked);
        localStorage.setItem('Password',this.loginForm.controls['password'].value);
        localStorage.setItem('Email',this.loginForm.controls['email'].value);
    } else {
        localStorage.removeItem('Remember');
        localStorage.removeItem('Password');
        localStorage.removeItem('Email');
    }
  }

  gotoRegister(e){
    this._router.navigate(["/register"]);
  }

  getRememberDetail() {
    let isRemember = localStorage.getItem('Remember');
    let username = localStorage.getItem('Email');
    let password = localStorage.getItem('Password');
    if (isRemember) {
      this.remmember = true;
      this.loginForm.controls['email'].setValue(username);
      this.loginForm.controls['password'].setValue(password);
      this.isCheck = true;
    }
  }
  
  triggerErrors(err) {
    Object.keys(this.loginForm.controls).forEach(key => {
      if (err[key]) {
        this.loginForm.controls[key].setErrors({'invalid': true});
        this.loginForm.controls[key].markAsTouched();
        this.loginForm.controls[key].markAsDirty();
      }
    });
  }
  
  clearStorage(){
    localStorage.removeItem('cashUser');
    localStorage.removeItem('isAdmin');
    localStorage.removeItem('token');
  }

}
